export const menuItems = [
  {
    path: '/app/dashboard',
    title: 'Dashboard',
    icon: 'mdi mdi-view-dashboard-outline'
  },
  {
    path: '/app/operation',
    title: 'Inicio / Cierre',
    icon: 'mdi mdi-gesture-double-tap'
  },
  {
    path: '/app/counter',
    title: 'Ingreso a Counter',
    icon: 'mdi mdi-car-info'
  },
  {
    path: '/app/registro',
    title: 'Termino de Inspección',
    icon: 'mdi mdi-file-document-edit-outline'
  },
  {
    path: '/app/facturacion',
    title: 'Facturación',
    icon: 'mdi mdi-cash-register'
  },
  {
    path: '/app/certificados',
    title: 'Impresión de Certificados',
    icon: 'mdi mdi-file-check-outline'
  },
  {
    path: '/app/contact-center',
    title: 'Contact center',
    icon: 'mdi mdi-headset'
  },
  {
    path: '/app/mtc-connection',
    title: 'Conexión MTC',
    icon: 'mdi mdi-access-point-network'
  },
  {
    path: '/app/reporte-mtc',
    title: 'Reporte MTC',
    icon: 'mdi mdi-file-document-outline'
  },
  {
    path: '/app/company',
    title: 'Compañía',
    icon: 'mdi mdi-hospital-building'
  },
  {
    path: '/app/plants',
    title: 'Plantas',
    icon: 'mdi mdi-domain'
  },
  {
    path: '/app/owners',
    title: 'Propietarios',
    icon: 'mdi mdi-account-details'
  },
  {
    path: '/app/logs-facturacion',
    title: 'Logs Facturación',
    icon: 'mdi mdi-file-document-multiple-outline'
  },
  {
    path: '/app/licencias-connect-vts',
    title: 'Licencias Connect VTS',
    icon: 'mdi mdi-key-chain-variant'
  },
  {
    path: '/app/ips',
    title: 'IPS',
    icon: 'mdi mdi-hospital-box'
  },
  {
    path: '/app/tablas-generales',
    title: 'Tablas Generales',
    icon: 'mdi mdi-table-large',
    children: [
      {
        path: '/app/tablas-generales?tab=certificate',
        title: 'Certificados'
      },
      {
        path: '/app/tablas-generales?tab=service',
        title: 'Servicios'
      },
      {
        path: '/app/tablas-generales?tab=categoria',
        title: 'Categoría'
      },
      {
        path: '/app/tablas-generales?tab=sector',
        title: 'Ámbito'
      },
      {
        path: '/app/tablas-generales?tab=inspection',
        title: 'Inspección'
      },
      {
        path: '/app/tablas-generales?tab=bodywork',
        title: 'Carrocería'
      },
      {
        path: '/app/tablas-generales?tab=insurer',
        title: 'Seguros'
      },
    ]
  },
]

export const defaultRouteByRole = {
  ROOT:       '/app/company',
  COMPANY:    '/app/plants',
  PLANT:      '/app/dashboard',
  COUNTER:    '/app/counter',
  TECHNICAL1: '/app/counter',
  TECHNICAL2: '/app/counter',
  TECHNICAL3: '/app/counter',
  CERTIFIER:  '/app/certificados',
  SUPERVISOR: '/app/operation',
}

// Roles con acceso permitido a esta plataforma web. Cualquier rol fuera de
// esta lista (ej: OWNER, que solo accede desde la app móvil) queda bloqueado.
export const allowedWebRoles = new Set([
  'TECHNICAL',
  ...Object.keys(defaultRouteByRole),
])
